import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Form,
  Layout,
  List,
  Modal,
  Row,
  Select,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { history } from "../../Helpers/history";
import NeedAuthService from "../../Services/needAuth.service";
import NotNeedAuthService from "../../Services/notNeedAuth.service";
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
import { validateConcurrentLogin } from "../../Actions/api";
import "./API.css";
function API() {

  const token = Cookies.get("JWToken");

  const { isLoggedIn } = useSelector((state) => state.auth);

  const { Option } = Select;

  let className = "API_nav_item";
  let className_focus = "API_nav_item focus_nav";

  const [render, updateRender] = useState(1);
  const [focus, setFocus] = useState(1);
  const [countryList, setCountry] = useState([]);
  const [categoryList, setCategory] = useState([]);
  const [categoryCountryList, setCategoryByCountry] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const handleMenuClick = (list) => {
    updateRender(list);
    setFocus(list);
    if(token !== undefined) {
      handleConcurrentLogin(token);
    }
  };

  const handleConcurrentLogin = (token) => {
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem('ConcurrencyLoginStamp');
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp));
      }
    }
  }

  const getCountryList = () => {
    const optionCountry = [];
    NotNeedAuthService.getCountryList().then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CountryName = response.Data[i].CountryName;
        var CountryCode = response.Data[i].CountryCode;
        optionCountry.push({
          label: CountryName,
          value: CountryCode,
          key: CountryCode,
        });
      }
      setCountry(optionCountry);
    });
  };

  const getAPIProductCategoryList = () => {
    var CategoryArray = [];
    var array = [];
    NotNeedAuthService.getAPIProductCategoryList().then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].Name;
        var CategoryType = response.Data[i].CategoryType;
        var CategoryDescription = response.Data[i].CategoryDescription;
        var CategoryHref = CategoryName.replace(/\s/g, "-");
        var Country = response.Data[i].Country;
        CategoryArray.push({
          name: CategoryName,
          type: CategoryType,
          desc: CategoryDescription,
          href: CategoryHref,
          country: Country,
        });
        var CountryList = Country.split(",");
        var href = "/APIs/SG/" + CategoryHref;
        for (var o = 0; o <= CountryList.length - 1; o++) {
          if (CountryList[o] === "SG") {
            if (CategoryType !== "OTHER") {
              array.push({
                name: CategoryName,
                type: CategoryType,
                desc: CategoryDescription,
                href: href,
              });
            }
          }
        }
      }
      setCategory(CategoryArray);
      setCategoryByCountry(array);
      setLoading(false);
    });
  };

  const getAPIProductCategoryListByCountry = (value) => {
    const array = [];
    for (var p = 0; p <= categoryList.length - 1; p++) {
      var Country = categoryList[p].country.split(",");
      var CategoryName = categoryList[p].name;
      var CategoryType = categoryList[p].type;
      var CategoryDescription = categoryList[p].desc;
      var CategoryHref = "/APIs/" + value + "/" + categoryList[p].href;
      for (var o = 0; o <= Country.length - 1; o++) {
        if (Country[o] === value) {
          if (CategoryType !== "OTHER") {
            array.push({
              name: CategoryName,
              type: CategoryType,
              desc: CategoryDescription,
              href: CategoryHref,
            });
          }
        }
      }
    }
    setCategoryByCountry(array);
  };

  const getCategory = async (id) => {
    var CategoryArray = [];
    var array = [];
    NeedAuthService.getCategory(id, 0).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].Name;
        var CategoryType = response.Data[i].CategoryType;
        var CategoryDescription = response.Data[i].CategoryDescription;
        var CategoryHref = CategoryName.replace(/\s/g, "-");
        var Country = response.Data[i].Country;

        CategoryArray.push({
          name: CategoryName,
          type: CategoryType,
          desc: CategoryDescription,
          href: CategoryHref,
          country: Country,
        });
        var CountryList = Country.split(",");
        var href = "/APIs/SG/" + CategoryHref;
        for (var o = 0; o <= CountryList.length - 1; o++) {
          if (CountryList[o] === "SG") {
            if (CategoryType !== "OTHER") {
              array.push({
                name: CategoryName,
                type: CategoryType,
                desc: CategoryDescription,
                href: href,
              });
            }
          }
        }
      }
      setCategory(CategoryArray);
      setCategoryByCountry(array);
      setLoading(false);
    });
  };

  const getUser = async () => {
    NeedAuthService.getUser().then((response) => {
      var partnerId = response.Data.PartnerId;
      getCategory(partnerId);
    });
  };

  function confirm() {
    Modal.confirm({
      title: "Log In Required",
      icon: <ExclamationCircleOutlined />,
      content: "Log In now to start using APIs Sandbox. We're waiting for you!",
      onOk() {
        history.push("/login");
      },
      okText: "Log In",
      cancelText: "I'll Be Back",
    });
  }

  useEffect(() => {
    getCountryList();
    if (isLoggedIn) {
        getUser();
    } else {
      getAPIProductCategoryList();
    }
  }, [isLoggedIn]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const data = [
    {
      title: <FormattedMessage id="Referral-nav1" />,
      key: 1,
    },
    {
      title: <FormattedMessage id="Referral-nav2" />,
      key: 2,
    },
    {
      title: <FormattedMessage id="Referral-nav3" />,
      key: 3,
    },
    {
      title: <FormattedMessage id="Referral-nav4" />,
      key: 4,
    },
    {
      title: <FormattedMessage id="Referral-nav5" />,
      key: 5,
    },
    {
      title: <FormattedMessage id="Referral-nav6" />,
      key: "6",
    },
  ];

  const item_list = (array) => [
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={8}
      xl={8}
      className="API-Col-Each"
      key={array.name}
    >
      <Card title={array.name}>
        <p>{array.desc}</p>
        {isLoggedIn ? (
          <Link to={array.href}>Documentation</Link>
        ) : (
          <Link to="#" onClick={confirm}>
            Documentation
          </Link>
        )}
      </Card>
    </Col>,
  ];

  const components = {
    1: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">All</p>
          <hr />
          <p className="nav_content">All APIs are available in current.</p>
        </div>
        <Row gutter={[16, 32]} justify="start">
          {categoryCountryList
            .sort((a, b) => (b.name > a.name ? 1 : -1))
            .map((array) => [item_list(array)])}
        </Row>
      </div>
    ),
    2: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">VEHICLE</p>
          <hr />
          <p className="nav_content">This APIs are regarding the vehicle.</p>
        </div>
        <Row gutter={[16, 32]} justify="start" className="row">
          {categoryCountryList.find(({ type }) => type === "VEHICLE") ? (
            categoryCountryList
              .sort((a, b) => (b.name > a.name ? 1 : -1))
              .map((array, id) => {
                if (array.type === "VEHICLE") {
                  return item_list(array);
                }
                return null;
              })
          ) : (
            <p className="api_empty">No APIs are active in current.</p>
          )}
        </Row>
      </div>
    ),
    3: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">PA</p>
          <hr />
          <p className="nav_content">This APIs are regarding the PA.</p>
        </div>
        <Row gutter={[16, 32]} justify="start" className="row">
          {categoryCountryList.find(({ type }) => type === "PA") ? (
            categoryCountryList
              .sort((a, b) => (b.name > a.name ? 1 : -1))
              .map((array, id) => {
                if (array.type === "PA") {
                  return item_list(array);
                }
                return null;
              })
          ) : (
            <p className="api_empty">No APIs are active in current.</p>
          )}
        </Row>
      </div>
    ),
    4: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">FIRE</p>
          <hr />
          <p className="nav_content">This APIs are regarding the FIRE.</p>
        </div>
        <Row gutter={[16, 32]} justify="start" className="row">
          {categoryCountryList.find(({ type }) => type === "FIRE") ? (
            categoryCountryList
              .sort((a, b) => (b.name > a.name ? 1 : -1))
              .map((array, id) => {
                if (array.type === "FIRE") {
                  return item_list(array);
                }
                return null;
              })
          ) : (
            <p className="api_empty">No APIs are active in current.</p>
          )}
        </Row>
      </div>
    ),
    5: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">BOND</p>
          <hr />
          <p className="nav_content">This APIs are regarding the BOND.</p>
        </div>
        <Row gutter={[16, 32]} justify="start" className="row">
          {categoryCountryList.find(({ type }) => type === "BOND") ? (
            categoryCountryList
              .sort((a, b) => (b.name > a.name ? 1 : -1))
              .map((array, id) => {
                if (array.type === "BOND") {
                  return item_list(array);
                }
                return null;
              })
          ) : (
            <p className="api_empty">No APIs are active in current.</p>
          )}
        </Row>
      </div>
    ),
    6: (
      <div className="container_API_catalog">
        <div className="AC_title">
          <p className="nav_title">LIFE</p>
          <hr />
          <p className="nav_content">This APIs are regarding the LIFE.</p>
        </div>
        <Row gutter={[16, 32]} justify="start" className="row">
          {categoryCountryList.find(({ type }) => type === "LIFE") ? (
            categoryCountryList
              .sort((a, b) => (b.name > a.name ? 1 : -1))
              .map((array, id) => {
                if (array.type === "LIFE") {
                  return item_list(array);
                }
                return null;
              })
          ) : (
            <p className="api_empty">No APIs are active in current.</p>
          )}
        </Row>
      </div>
    ),
  };

  return [
    <div className="select_country">
      <Row style={{ widht: "98%" }}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className="select_following"
        >
          I want to see APIs in :
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form
            {...layout}
            layout="vertical"
            name="basic"
            initialValues={{
              Market: "Singapore",
            }}
          >
            <Row justify="center" align="middle">
              <Col xs={22} sm={22} md={22} lg={8} xl={8}>
                <Form.Item
                  label={
                    <label style={{ color: "white", fontSize: "1rem" }}>
                      Market
                    </label>
                  }
                  name="Market"
                  className="s_item_c"
                >
                  <Select
                    size="large"
                    onChange={getAPIProductCategoryListByCountry}
                  >
                    {countryList.map((p) => (
                      <Option key={p.value}>{p.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={22} sm={22} md={22} lg={8} xl={8}></Col>
              <Col xs={22} sm={22} md={22} lg={8} xl={8}></Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>,
    <div>
      <Row>
        <Col xs={24} sm={24} md={24} lg={1} xl={1}></Col>
        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
          <List
            dataSource={data}
            className="type_menu_nav"
            renderItem={(item) => (
              <List.Item
                key={item.key}
                onClick={() => handleMenuClick(item.key)}
                className={item.key === focus ? className_focus : className}
              >
                <span>{item.title}</span>
              </List.Item>
            )}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={17} xl={17}>
          <Layout style={{ background: "white" }}>
            {loading === false ? (
              components[render]
            ) : (
              <div className="container_API_catalog">
                <Skeleton active size="large" />
                <br />
                <Skeleton active size="large" />
                <br />
                <Skeleton active size="large" />
              </div>
            )}
          </Layout>
        </Col>
      </Row>
    </div>,
  ];
}

export default API;
